import * as React from "react";

function Menu(props) {
  return (
    <svg width={43} height={45} fill="none" {...props}>
      <path fill="url(#prefix__pattern0_6018_16)" d="M0 0h43v45H0z" />
      <defs>
        <pattern
          id="prefix__pattern0_6018_16"
          patternContentUnits="objectBoundingBox"
          width={1}
          height={1}
        >
          <use
            xlinkHref="#prefix__image0_6018_16"
            transform="matrix(.01 0 0 .00956 0 .022)"
          />
        </pattern>
        <image
          id="prefix__image0_6018_16"
          width={100}
          height={100}
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACiElEQVR4nO3czW5NURQH8KWDvW7TlhESDHwkwrjO+ti5VGuAhAjiXSgP4AW0nsPXQxQtr4EBRlpJj+zbShoPYK3e8/8l//k9a5+z9z0fexEBAAAAAAAAAAAAAAAAAAAAAISaUz1ZVJ+y6Rs23WDXD1MZ0412jMVkdc79BGVUqj5kk5/s2g8sP4rqA8qEVa+zye8ExemDsjPy7hplwS6fExSlD43pJ8qgqF4OL4bnSHG/FD0eVMzuRheCk6R4dyfDdLUSXQhOE1mJHg+ixcVj7LodXwyNjckvEjlKGRSXtfCCeGyKyQtKo9YFNtmMLgqHRT7S0tI8pVLrQnFdH9j0tT25MtINxr9rSpXl4vJomsNVltOsGQAAAAAAAABwSMy0dwLF9RmbPJ/mlHaM7fEJ0QxlNHmVa7o1xCe9JcOr24O41gvF9Vt8cTQkxfUrj6+cpyzY5V10UTg6Jm8pg1mRM+y6G14QD8/urNnpDGvH7QTF6FPE7Fb0eFD7EeGF8CzpbkaPB7XLFFOWtgHZna31FGXQFrT4s1NjY/qasmCRc5O/ftFF8ZgUky+sepYyaTdH7SZpgFfG+9J1FympmbY1YW/TzpQ/OjFZHZktEdGR6KIDAAAAAAAAwOEx2QTavjyZ8g07LivtWCmtvS1tLwe3pc1lLd+WtsmmzyF+AqT7T3xls9WAsti/Mvohp7iuUwpoHND/nb5SrCns3Y3os5PTJEFrDTSf0VzNZ9CeSQ8MSJJvfFvzrvjpQmNjukVZjKpcbW3uwoviYdkZqY4pk2Ld/dYQMkFx+v+c76XKPcqotUwtJk/aR2NT3ybW5VVxfTw/Hh+PrjsAAAAAAAAAAAAAAAAAAAAA0MD9AWRLmc5t9sgyAAAAAElFTkSuQmCC"
        />
      </defs>
    </svg>
  );
}

export default Menu;
